/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const S3_PREFIX = "https://media.werz.at/community-assets/KUNEJULY25"

const kuneJuly25: CommunityData = {
  code: "kune",
  name: "KUNE",
  inviteCode: "joinkune",
  thumbnail: "",
  favicon: "",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/kune`,
  socials: {
    instagramLink: "",
    soundcloudLink: "",
  },
  styles: {
    global: {
      counterColor: "#ffba49",
      alternativeLogo: {
        src: `${S3_PREFIX}/web-alternative-logo.png`,
        styles: "w-32 h-32 object-contain",
      },
      logo: {
        src: `${S3_PREFIX}/web-logo.png`,
        styles: "w-32 h-32 object-contain",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#f5f2eb",
      asideBg: "#F5F2EB",
      asideStyles: "border-r border-[#6d6d6d]",
      contentBg: "#f5f2eb",
      contentBoxShadow: "",
      bgDesktop: `${S3_PREFIX}/web-background.jpg`,
      bgMobile: `${S3_PREFIX}/web-background.jpg`,
      nonMemberBg: `${S3_PREFIX}/web-nonauth-bg.mp4?type=video`,
      mainFont: "font-['DanceV2Regular']",
      primaryButton:
        "bg-[#ffba49] border border-[#1a1b1f] px-[18px] py-[18px] !text-[#1a1b1f] font-['DanceV2Regular'] text-[18px] text-left",
    },
    navigation: {
      iconsColor: "#000000",
      sideBarSeparator: "#1A1B1F",
      separator: "border-t-[#1A1B1F] border-t",
      item: "text-[#000000] font-['DanceV2Regular'] text-[16px] text-center gap-[10px] sm:!pl-0 sm:!py-3 opacity-50",
      itemSelected: "text-[#000000] font-['DanceV2Regular'] text-[16px] text-center !opacity-100",
    },
    communityLanding: {
      container: "bg-[#f5f2eb] pb-8",
      titles: "text-[#000000] font-['DanceV2Regular'] text-[30px] text-left",
      emptyOrLoadingState:
        "!mx-4 sm:!mx-8 text-[#444444] font-['FAIRESprigSansMonoRegular'] text-[12px] text-left",
      announcementsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 !space-y-0 border-b border-[#1A1B1F]",
        sectionTitle: "pl-4 sm:!pl-8 !pb-4 sm:!pb-6",
        scrollMenu: {
          container: "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 gap-x-4",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          container:
            "min-w-[calc(100vw-48px)] sm:min-w-[256px] sm:max-w-[256px] h-full overflow-hidden border border-[#1A1B1F]",
          mediaContainer: "w-full sm:w-[256px] !aspect-square relative",
          media: "w-full !aspect-square object-cover",
          placeholderMedia: "w-full h-full bg-gray-400",
          content: "flex flex-col p-4 bg-[#f5f2eb]",
          title: "text-[#000000] font-['DanceV2Regular'] text-[18px] text-left",
          subtitle: "text-[#444444] font-['FAIRESprigSansMonoRegular'] text-[12px] text-left",
        },
      },
      eventsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 !space-y-0 border-b border-[#1A1B1F]",
        sectionTitle: "pl-4 sm:pl-8 !pb-4 sm:!pb-6",
        scrollMenu: {
          container:
            "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 !h-full sm:!h-[128px] flex-row gap-6",
          wrapper: "relative group w-full",
          item: "w-fit",
        },
        item: {
          container:
            "flex sm:flex-row flex-col w-[calc(100vw-56px)] sm:!w-[428px] h-full overflow-hidden border border-[#1A1B1F]",
          mediaContainer: "w-full sm:!w-[228px] sm:flex-shrink-0 relative overflow-hidden",
          media: "w-full !aspect-video object-cover",
          placeholderMedia: "w-full h-full bg-gray-400",
          content: "flex flex-col p-4 bg-[#f5f2eb]",
          title: "text-[#000000] font-['DanceV2Regular'] sm:text-[15px] text-[18px] text-left",
          subtitle: "text-[#444444] font-['FAIRESprigSansMonoRegular'] text-[12px] text-left",
          location: "text-[#444444] font-['FAIRESprigSansMonoRegular'] text-[12px] text-left",
          date: "text-[#444444] font-['FAIRESprigSansMonoRegular'] text-[12px] text-left",
        },
      },
      shop: {
        container: "py-4 sm:pb-8 !pb-16 !m-0 space-y-0",
        title: "text-[#000000] font-['DanceV2Regular'] text-[22px] text-left",
        text: "text-[#000000] font-['FAIRESprigSansMonoRegular'] text-[12px] text-left",
        customShopImageStyle: "",
        sectionTitle: "!mb-4 sm:!mb-6",
      },
    },
    eventV2: {
      container: "flex flex-col bg-[#f5f2eb] pb-8",
      eventInfo: {
        container: "flex flex-col sm:flex-row gap-4 sm:gap-8 sm:p-8 p-4 border-b border-[#1A1B1F]",
        media: "sm:!w-[320px] !w-full !h-[180px] object-cover sm:mb-4 r= !border-0",
        title: "text-[#000000] font-['DanceV2Regular'] text-[30px] text-left",
        subtitle: "text-[#444444] font-['FAIRESprigSansMonoRegular'] text-[12px] text-left",
        button:
          "mt-4 mb-4 sm:mb-0 bg-[#ffba49] border border-[#1a1b1f] px-[18px] py-[18px] !text-[#1a1b1f] font-['DanceV2Regular'] text-[18px] text-left",
        questions: "font-['FAIRESprigSansMonoRegular'] text-[12px] text-left",
      },
      about: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#1A1B1F]",
        header: "text-[#000000] font-['DanceV2Regular'] text-[30px] text-left",
        text: "text-[#000000] font-['FAIRESprigSansMonoRegular'] text-[12px] text-left",
      },
      location: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#1A1B1F]",
        header: "text-[#000000] font-['DanceV2Regular'] text-[30px] text-left",
        text: "text-[#000000] font-['FAIRESprigSansMonoRegular'] text-[12px] text-left",
        map: "border border-[#1A1B1F] gap-[10px] overflow-hidden",
        mapPinColor: "#1a1b1f",
        mapStrokeColor: "#1A1B1F",
      },
      downloadWERZ: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header: "text-[#000000] font-['DanceV2Regular'] text-[30px] text-left",
        text: "text-[#000000] font-['FAIRESprigSansMonoRegular'] text-[12px] text-left",
      },
      tickets: {
        header:
          "text-[#000000] font-['DanceV2Regular'] text-[30px] text-left flex justify-between items-center",
        outerContainer: "flex flex-col sm:p-8 p-4 bg-[#f5f2eb] pb-8",
        innerContainer: "flex flex-col border-b border-[#1A1B1F]",
        accessCode: {
          button:
            "py-3 text-[#1A1B1F] font-['FAIRESprigSansMonoRegular'] text-[12px] text-left underline underline-offset-2 !w-fit",
        },
        ticket: {
          container:
            "flex flex-row justify-between gap-3 p-3 border border-b-0 border-[#1A1B1F] leading-auto tracking-[0.04em]",
          media: "!border-0",
          mediaContainer: "!h-16 !w-16 !min-w-16 !max-w-16 mr-3",
          name: "text-[#000000] font-['DanceV2Regular'] text-[16px] text-left",
          description: "text-[#444444] font-['FAIRESprigSansMonoRegular'] text-[12px] text-left",
          price: "text-[#444444] font-['DanceV2Regular'] text-[16px] text-left",
          quantity: "text-[#f5f2eb] font-['FAIRESprigSansMonoRegular'] text-[12px] text-left",
          status: "text-[#444444] font-['DanceV2Regular'] text-[16px] text-left",
          counterContainer: "bg-[#216ce0] border border-[#1a1b1f] px-3 py-3 gap-4",
          plusMinusColor: "#f5f2eb",
          button:
            "bg-[#216ce0] border border-[#1a1b1f] px-3 py-3 text-[#f5f2eb] font-['FAIRESprigSansMonoRegular'] text-[12px] text-left",
        },
      },
    },
  },
}

export default kuneJuly25
